/*
 * Become a partner form.
 *
 * Two jobs:
 *
 * 1. Billing address toggle. "Billing address is the same as shipping address"
 *    is checked by default. While checked the billing fields are hidden AND
 *    disabled so they are not submitted, and a hidden contact[Billing address]
 *    field carries "Same as shipping address" into the notification email.
 *
 * 2. Country-aware address fields, mirroring Shopify checkout. Some countries
 *    have no postal code at all (UAE, Hong Kong, Qatar and 60+ others) and some
 *    need a state, province, emirate or prefecture. Asking a dealer in Dubai for
 *    a required zip code is a dead end, so the field is hidden rather than left
 *    empty and optional.
 *
 * The two lists below come from Shopify's own country service, the same data
 * their checkout uses: countries whose address format has no {zip}, and those
 * whose format has a {province} plus the label that country uses for it. Both
 * carry the shop's dropdown spelling and Shopify's current spelling, so a rename
 * like "Hong Kong" to "Hong Kong SAR" does not silently break the match.
 *
 * The state options themselves are not hardcoded. They are read from the
 * data-provinces attribute Shopify already puts on every country option, so they
 * stay in sync on their own.
 */
(function () {
  var NO_POSTAL_CODE = [
    "angola", "anguilla", "antigua & barbuda", "aruba", "ascension island", "bahamas",
    "belize", "benin", "bolivia", "botswana", "burundi", "cameroon", "caribbean netherlands",
    "central african republic", "chad", "christmas island", "cocos (keeling) islands",
    "comoros", "congo", "congo - brazzaville", "congo - kinshasa",
    "congo, the democratic republic of the", "cook islands", "curaçao", "côte d’ivoire",
    "djibouti", "dominica", "equatorial guinea", "eritrea", "falkland islands", "fiji",
    "gabon", "gambia", "gibraltar", "grenada", "guyana", "hong kong", "hong kong sar",
    "jamaica", "macao", "macao sar", "mali", "mauritania", "nauru", "niue", "norfolk island",
    "pitcairn islands", "qatar", "republic of cameroon", "rwanda", "seychelles",
    "sierra leone", "sint maarten", "solomon islands",
    "south georgia & south sandwich islands", "south sudan", "st. helena", "suriname",
    "são tomé & príncipe", "timor-leste", "togo", "tokelau", "tonga", "tristan da cunha",
    "turks & caicos islands", "tuvalu", "uganda", "united arab emirates", "vanuatu",
    "vatican city", "yemen", "zimbabwe"
  ];

  var ZONE_LABELS = {
    "argentina": "Province",
    "australia": "State/territory",
    "brazil": "State",
    "canada": "Province",
    "chile": "Region",
    "china": "Province",
    "colombia": "Province",
    "costa rica": "Province",
    "egypt": "Governorate",
    "el salvador": "Department",
    "guatemala": "Region",
    "hong kong": "Region",
    "hong kong sar": "Region",
    "india": "State",
    "indonesia": "Province",
    "ireland": "County",
    "italy": "Province",
    "japan": "Prefecture",
    "kuwait": "Governorate",
    "malaysia": "State/territory",
    "mexico": "State",
    "new zealand": "Region",
    "nigeria": "State",
    "panama": "Region",
    "peru": "Region",
    "philippines": "Region",
    "portugal": "Region",
    "romania": "County",
    "russia": "Region",
    "south africa": "Province",
    "south korea": "Province",
    "spain": "Province",
    "thailand": "Province",
    "united arab emirates": "Emirate",
    "united states": "State",
    "uruguay": "Department",
    "venezuela": "Region"
  };

  // Accents, curly apostrophes and "and" versus "&" all differ between the
  // shop's dropdown and Shopify's current names, so both sides go through key().
  function key(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[‘’']/g, '')
      .trim()
      .toLowerCase()
      .replace(/\s+and\s+/g, ' & ')
      .replace(/\s+/g, ' ');
  }

  var noPostalCode = {};
  NO_POSTAL_CODE.forEach(function (name) { noPostalCode[key(name)] = true; });

  var zoneLabels = {};
  Object.keys(ZONE_LABELS).forEach(function (name) {
    zoneLabels[key(name)] = ZONE_LABELS[name];
  });

  function provincesFor(select) {
    if (!select || select.selectedIndex < 0) return [];
    var option = select.options[select.selectedIndex];
    if (!option) return [];
    try {
      var parsed = JSON.parse(option.getAttribute('data-provinces') || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function fillStates(select, provinces) {
    var wanted = select.getAttribute('data-state-value') || select.value;
    select.innerHTML = '';

    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = 'Select';
    select.appendChild(placeholder);

    provinces.forEach(function (province) {
      var name = Array.isArray(province) ? province[1] || province[0] : province;
      var option = document.createElement('option');
      option.value = name;
      option.textContent = name;
      select.appendChild(option);
    });

    if (wanted) select.value = wanted;
    // Only honour a repopulated value once, so it cannot override a later change.
    select.removeAttribute('data-state-value');
  }

  function setRequired(field, required) {
    if (required) {
      field.setAttribute('required', 'required');
    } else {
      field.removeAttribute('required');
    }
  }

  function applyGroup(form, group, active) {
    var country = form.querySelector('[data-country-select="' + group + '"]');
    if (!country) return;

    var name = key(country.value);
    var zipCol = form.querySelector('[data-zip-col="' + group + '"]');
    var stateCol = form.querySelector('[data-state-col="' + group + '"]');
    var zip = zipCol ? zipCol.querySelector('[data-zip-input]') : null;
    var state = stateCol ? stateCol.querySelector('[data-state-select]') : null;
    var label = stateCol ? stateCol.querySelector('[data-state-label]') : null;

    if (zipCol && zip) {
      var wantsZip = !noPostalCode[name];
      zipCol.hidden = !wantsZip;
      zip.disabled = !active || !wantsZip;
      setRequired(zip, active && wantsZip);
      if (!wantsZip) zip.value = '';
    }

    if (stateCol && state) {
      var zoneLabel = zoneLabels[name];
      var provinces = provincesFor(country);
      var wantsState = !!zoneLabel && provinces.length > 0;

      if (wantsState) {
        fillStates(state, provinces);
        if (label) label.textContent = zoneLabel;
      } else {
        state.innerHTML = '';
        state.value = '';
      }

      stateCol.hidden = !wantsState;
      state.disabled = !active || !wantsState;
      setRequired(state, active && wantsState);
    }
  }

  function init(form) {
    if (form.dataset.b2bSignupBound === 'true') return;
    form.dataset.b2bSignupBound = 'true';

    var toggle = form.querySelector('[data-billing-same]');
    var fields = form.querySelector('[data-billing-fields]');
    var hidden = form.querySelector('[data-billing-same-hidden]');
    var countries = form.querySelectorAll('[data-country-select]');
    if (!countries.length) return;

    function apply() {
      var same = toggle ? toggle.checked : true;

      if (fields) fields.hidden = same;
      if (hidden) hidden.disabled = !same;

      if (fields) {
        fields.querySelectorAll('[data-billing-input]').forEach(function (input) {
          // Zip and state are owned by applyGroup, which runs next.
          if (input.hasAttribute('data-zip-input')) return;
          if (input.hasAttribute('data-state-select')) return;
          input.disabled = same;
          if (input.hasAttribute('data-billing-optional')) return;
          setRequired(input, !same);
        });
      }

      applyGroup(form, 'shipping', true);
      applyGroup(form, 'billing', !same);
    }

    if (toggle) toggle.addEventListener('change', apply);
    countries.forEach(function (select) {
      select.addEventListener('change', apply);
    });

    apply();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.contact-form').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
